import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../constants';
import './Footer.css';

function Footer({ fullWidth = false }) {
  const currentYear = new Date().getFullYear();
  const className = fullWidth ? 'app-footer app-footer--full-width' : 'app-footer';

  return (
    <footer className={className}>
      <div className="footer-content">
        {/* Copyright */}
        <p className="footer-copyright">
          &copy; {currentYear} Polar Ace. All rights reserved.
        </p>

        {/* Links */}
        <nav className="footer-links" aria-label="Footer navigation">
          <Link to={ROUTES.TERMS} className="footer-link">
            Terms of Service
          </Link>
          <span className="footer-separator" aria-hidden="true">
            ·
          </span>
          <Link to={ROUTES.PRIVACY} className="footer-link">
            Privacy Policy
          </Link>
          <span className="footer-separator" aria-hidden="true">
            ·
          </span>
          <Link to={ROUTES.GUIDELINES} className="footer-link">
            Community Guidelines
          </Link>
          <span className="footer-separator" aria-hidden="true">
            ·
          </span>
          <Link to={ROUTES.CONTACT} className="footer-link">
            Contact
          </Link>
        </nav>

        {/* Tagline */}
        <p className="footer-tagline">For the streamers who want more.</p>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  fullWidth: PropTypes.bool,
};

export default Footer;
